import { executeRequest, JFSRequest } from '@jfs/network'
import { isEmpty } from 'lodash'
import { isSuccessResponse } from '../utils'
import { accountTypeArr } from '../utils/constants'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  const payoutAcc = data?.payoutSourceAccount ?? []
  const retData = payoutAcc?.map((item) => {
    return {
      id: item?.id,
      accNumber: item?.accountNumber,
      ifscCode: item?.bankIfsc,
      accType: accountTypeArr?.find((obj) => obj.id === item?.accountType)?.value,
      accountName: item?.metadata?.accountName,
      clientCode: item?.metadata?.clientCode,
      remarks: item?.remarks ?? '',
      startDate: new Date(item?.startDate)?.getTime(),
      endDate: new Date(item?.endDate)?.getTime(),
     // startDate: new Date(item?.startDate)>new Date()?new Date(item?.startDate)?.getTime():undefined,
     // endDate: new Date(item?.endDate)>new Date()?new Date(item?.endDate)?.getTime():undefined,
 
      processingEntity: item?.processingEntity?.toString(),
      //transactionModes: item?.transactionMode,
      methodTypes: item?.methodType?.split('|')?.map((item) => {
        return {
          id: item,
          value: item ?? 'NA',
        }
      }),
      methodSubTypes: item?.methodSubType?.split('|')?.map((item) => {
        return {
          id: item,
          value: item ?? 'NA',
        }
      }),
      entityType: item?.entityType?.split('|')?.map((item) => {
        return {
          id: item,
          value: item ?? 'NA',
        }
      }),
      transactionModes: item?.transactionMode?.split('|')?.map((item) => {
        return {
          id: item,
          value: item ?? 'NA',
        }
      }),
    }
  })
  return retData
}
const getSourceAccConfig = (tokens: any, groupId: string, subGroupId: string) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.retriveSourceAccount),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entity: {
        initiatingEntityId: REACT_APP_CHANNEL_ID,
        groupId: groupId,
        subGroupId: isEmpty(subGroupId) ? undefined : subGroupId,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getSourceAccConfig }
